export var SvgIconOverrides = function () { return ({
    MuiSvgIcon: {
        fontSizeSmall: {
            fontSize: 16,
        },
        fontSizeLarge: {
            fontSize: 38,
        },
    },
}); };
//# sourceMappingURL=SvgIcon.overrides.js.map